import {UnstyledButton} from '@nib-components/button';

export default UnstyledButton;
